import { createContext, useContext } from 'react';
import { CmsDataType } from '../../services/cmsData';

const ContentManagerContext = createContext<CmsDataType>(undefined!);

export const ContentManagerContextProvider = ContentManagerContext.Provider;

export const useCMSData = () => useContext(ContentManagerContext);
